module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Layout Admin */

(function (fox, $) {
  "use strict";

  fox.registerWidget("Layout_Admin_Header", {
    configure: function () {
      this.registerOptions("", {
        template: "layout_admin_header",
        autoRender: true,
        container: ".header-wrapper",
        widgets: {
          // banner: {
          // 	widget: 'ReferralContestBanner'
          // },
          layoutHeader: {
            widget: "Layout_Admin_LayoutHeader",
          },
          throughNotifications: {
            widget: "ThroughNotifications",
          },
        },

        handleWom: {
          insertAvatar: {
            widget: "#clientDataApi",
            event: "success",
            callback: "_handleApi",
          },
        },
      });

      this.callParent("configure", arguments);
    },

    getHeight: function () {
      return $(this.element[0]).height();
    },

    getNotice: function () {
      return this.wom1("#throughNotifications");
    },
  });
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/layout/admin/header/header.js
// module id = 315
// module chunks = 2